import {
  Icon,
  type IconName,
  ToggleGroup,
  ToggleGroupItem,
  Tooltip,
  TooltipPopup,
  TooltipTrigger,
} from "@salestrak/ui";

export type ViewModeOption<M extends string> = { mode: M; label: string; icon: IconName };

/** Base UI reports a re-press as an empty value and the controlled `value` snaps it back, so one mode stays down. */
export function ViewModeToggle<M extends string>({
  modes,
  mode,
  onModeChange,
}: {
  modes: readonly ViewModeOption<M>[];
  mode: M;
  onModeChange: (mode: M) => void;
}) {
  return (
    <ToggleGroup
      aria-label="View as"
      onValueChange={(next: string[]) => {
        const picked = modes.find((option) => option.mode === next[0]);
        if (picked) onModeChange(picked.mode);
      }}
      size="xs"
      value={[mode]}
      variant="outline"
    >
      {modes.map((option) => (
        <Tooltip key={option.mode}>
          <TooltipTrigger render={<ToggleGroupItem aria-label={option.label} value={option.mode} />}>
            <Icon name={option.icon} size="sm" />
          </TooltipTrigger>
          <TooltipPopup side="bottom">{option.label}</TooltipPopup>
        </Tooltip>
      ))}
    </ToggleGroup>
  );
}
